import React from 'react';
import { createStateContext } from 'react-use';

import { Variable } from '../../../lib/App';
import { TreatmentDefaultColors, TreatmentIds } from '../helper/consts';

export type Treatment = {
  id: string;
  name: string;
  description?: string;
  color: string;
};
const [useVariables, VariablesProvider] = createStateContext<Variable[]>([]);
const [useTreatments, TreatmentsProvider] = createStateContext<Treatment[]>([
  {
    id: TreatmentIds[0],
    name: TreatmentIds[0],
    color: TreatmentDefaultColors[TreatmentIds[0]],
  },
  {
    id: TreatmentIds[1],
    name: `Treatment ${TreatmentIds[1]}`,
    color: TreatmentDefaultColors[TreatmentIds[1]],
  },
]);

const ExperimentFormInfoProvider = ({ children }) => {
  return (
    <TreatmentsProvider>
      <VariablesProvider>{children}</VariablesProvider>
    </TreatmentsProvider>
  );
};

export { ExperimentFormInfoProvider, useVariables, useTreatments };
